<template>
  <b-container fluid>

    <esg-base-card title="탄소배출권 예상 구매비용"
                   :footer="false">
      <b-container fluid>
        <b-row align-h="start">
          <b-col md="6"
                 lg="4">
            <esg-single-score-card :title="`당해년도 배출권 예상 구매 비용(${currentYear}년)`"
                                   :score="formatNumber(currentYearCost / 10e6, 0)"
                                   score-unit="백만원"
                                   color='yellow'
                                   :loading="loading"/>
          </b-col>
          <b-col md="6"
                 lg="4">
            <esg-single-score-card :title="`누적 배출권 예상 구매 비용(${currentYear}~50년)`"
                                   :score="formatNumber(cumulativeCost / 10e6, 0)"
                                   score-unit="백만원"
                                   color='yellow'
                                   :loading="loading"/>
          </b-col>
        </b-row>

        <b-row class="mt-3">
          <b-col>
            <esg-base-dashboard-card title="배출 할당초과에 따른 탄소배출권 예상구매비용"
                                     subtitle="(환경부 제3기 배출권 할당기준)">
              <template #actions>
                <esg-base-select-box label="기간"
                                     v-model="lastYear">
                  <option value="2030">단기</option>
                  <option value="2050">장기</option>
                </esg-base-select-box>
              </template>

              <firmwide-expected-kau-purchase-cost-by-year :last-year="Number(lastYear)"/>
            </esg-base-dashboard-card>
          </b-col>
        </b-row>
      </b-container>
    </esg-base-card>
  </b-container>
</template>
<script>
import EsgBaseDashboardCard from "@/components/esg/base/EsgBaseDashboardCard.vue"
import EsgSingleScoreCard from "@/components/esg/base/EsgSingleScoreCard.vue";
import EsgBaseCard from "@/components/esg/base/EsgBaseCard.vue";
import FirmwideExpectedKauPurchaseCostByYear from "@/components/esg/3. Monitoring/charts2/FirmwideExpectedKauPurchaseCostByYear.vue";
import EsgBaseSelectBox from "@/components/esg/base/form/EsgBaseSelectBox.vue";

export default {
  name: 'EsgCarbonExpectedPurchaseCost',
  components: {
    EsgBaseSelectBox,
    EsgBaseCard,
    EsgBaseDashboardCard,
    EsgSingleScoreCard,
    FirmwideExpectedKauPurchaseCostByYear
  },
  data() {
    return {
      loading: false,
      lastYear: 2050,
      currentYearCost: 0,
      cumulativeCost: 0,
      list: [],
    }
  },
  created() {
    this.fetchData();
  },
  methods: {

    /**
     * Fetches expected KAU purchase cost for the current year and the future years up to 2050
     */
    async fetchData() {
      try {
        this.loading = true;

        let args = [{
          years: Array.from({ length: 2050 - this.currentYear + 1 }, (_, i) => this.currentYear + i)
        }]

        let params = new FormData()
        params.append('path', 'esg/kau_purchase_cost/main')
        params.append('json', JSON.stringify(args))

        let response = await axios.post('esg/lca/run/python/chart-data', params, {
          headers: { Authorization: accessToken() },
        });

        if (!response.data.data) return;

        this.list = JSON.parse(response.data.data)[0].data;

        let currentYearData = this.list.find(row => row.year === this.currentYear);
        this.currentYearCost = currentYearData ? currentYearData.expected_kau_purchase_cost : 0;
        this.cumulativeCost = this.list.map(row => row.expected_kau_purchase_cost).reduce((a, b) => a + b, 0);
      } catch (error) {
        this.loading = false;
        await this.showError(error);
      } finally {
        this.loading = false;
      }
    },
  },
}
</script>
